import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'loaderElement'
  ];

  deactivateLinkAndShowLoader(e) {
    e.target.classList.add('disabled-link');
    e.target.textContent = 'Pobieranie informacji z NIP24';
    this.loaderElementTarget.classList.remove('hidden');
  }
}
